// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mRwB","right":"styles_right__8mU3x"};